import styled from 'styled-components';

export const HarvestedLotsReport = styled.div`
  background: white;
  min-height: 100%;
`
